<template>
	<div class="marquee-btn">
		<div class="marquee-effect">
			<div class="gradient"></div>
			<div class="spotlight"></div>
			<div class="placeholder">
				<slot></slot>
			</div>
		</div>
		<Button v-bind="$attrs">
			<slot></slot>
		</Button>
	</div>
</template>

<script>
import Button from '@/components/base/Button';

export default {
	name: 'MarqueeButton',
	components: {
		Button,
	},
};
</script>

<style lang="scss" scoped>
	$gradient-1: #9A5D37;
	$gradient-2: #EFD279;
	$gradient-3: #202641;
	$gradient-4: #3B639B;

	.marquee-btn, .btn {
		transition: all $ui-transition-duration-short;
		font-family: $heading-font;
		font-size: $font-size-xl;
		width: max-content;
		margin: 0 0 20px 0;
	}

	.marquee-btn {
		border-radius: .5em;
		overflow: hidden;
		position: relative;
		border: $border-width-sm solid $gradient-1;
		mask-image: -webkit-radial-gradient(white, black);

		&:active { transform: scale(0.98); }
	}

	.placeholder,
	.btn {
		text-transform: uppercase;
		background: black;
		color: white;
		padding: .4em .75em;
		margin: .25em;
		border-radius: .25em;
		border: $border-width-sm solid $gradient-2;
		line-height: 1;
		letter-spacing: $letter-spacing-plus;
	}

	.btn {
		width: unset;
		position: absolute;
		top: 0;
		background: linear-gradient(
			90deg, $gradient-3 0%, $gradient-4 50%, $gradient-3 100%
		);

		.little-bummer & {
			background: linear-gradient(
				90deg, $little-bummer-1 0%, $little-bummer-2 50%, $little-bummer-1 100%
			);
		}

		.big-bummer & {
			background: linear-gradient(
				90deg, $big-bummer-1 0%, $big-bummer-2 50%, $big-bummer-1 100%
			);
		}

		.jackpot & {
			background: linear-gradient(
				90deg, $jackpot-1 0%, $jackpot-2 50%, $jackpot-1 100%
			);
		}

		.trivia & {
			background: linear-gradient(
				90deg, $trivia-1 0%, $trivia-2 50%, $trivia-1 100%
			);
		}
	}

	.marquee-effect {
		max-width: 16ch;
		overflow: hidden;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		filter: contrast(110%) brightness(120%); // The blend modes mute the colors
	}

	.gradient,
	.spotlight {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		pointer-events: none;
		z-index: 10;
	}

	.gradient {
		background: linear-gradient(45deg, $gradient-2, $gradient-1);
		mix-blend-mode: multiply;
		border-radius: .25em;
	}

	.spotlight {
		animation: light-drift 15s infinite linear;
		background:
			radial-gradient(circle, white, transparent 25%) 0 0 / 25% 25%,
			radial-gradient(circle, white, black 25%) 50% 50% / 12.5% 12.5%;
		top: -100%;
		left: -100%;
		mix-blend-mode: color-dodge; // Color dodge gives the lights that shimmer effect
	}

	@keyframes light-drift {
		100% { transform: translate3d(50%, 50%, 0); }
	}
</style>
